module.exports = __webpack_public_path__ + "static/media/sidebar.b3c2a311.png";